






import { Component, Vue } from 'vue-property-decorator'
import { AnimatedSprite, Application, Loader } from 'pixi.js'
import { list } from '@/utils/loading'
let app: Application
@Component({})
export default class PixiAni extends Vue {
  mounted() {
    console.log('mounted')
    const loader = Loader.shared
    const dom = this.$refs.pixi as HTMLCanvasElement

    app = new Application({
      view: dom,
      width: 400,
      height: 400,
      resolution: Math.min(window.devicePixelRatio, 2),
      transparent: true,
    })
    let textureList: any = []
    list.forEach((i) => {
      const map: any = loader.resources[i].textures
      const keyList = Object.keys(map)
      const fList = keyList.map((j) => map[j])
      textureList = [...textureList, ...fList]
    })
    const sp = new AnimatedSprite(textureList)
    sp.loop = true
    sp.animationSpeed = 0.25
    sp.play()
    app.stage.addChild(sp)
  }
  beforeDestroy() {
    app && app.destroy()
  }
}
